export class ModalPopupHookService {
  public static readonly ModalCompMap: Map<number, any> = new Map();

  static register(key: number, component: any): void {
    if (this.ModalCompMap.get(key)) {
      console.warn(`Modal component for key "${key}" is already registered.`);
    }
    if (!component) {
      throw new Error(`Component for key "${key}" is not provided.`);
    }
    this.ModalCompMap.set(key, component);
  }
}
